module.exports = __webpack_public_path__ + "AI-FABwp510c6fb65f08ac5f588a82fea6dfdcda.png";